import { render, staticRenderFns } from "./School.vue?vue&type=template&id=2c3863e8&scoped=true&"
import script from "./School.vue?vue&type=script&lang=js&"
export * from "./School.vue?vue&type=script&lang=js&"
import style0 from "./School.vue?vue&type=style&index=0&id=2c3863e8&lang=less&scoped=true&"
import style1 from "./School.vue?vue&type=style&index=1&id=2c3863e8&lang=less&scoped=true&"
import style2 from "./School.vue?vue&type=style&index=2&id=2c3863e8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3863e8",
  null
  
)

export default component.exports